import { call } from 'redux-saga/effects';
import { makeApiRequest } from 'helpers/makeApiRequest';
import { AllocatePayload, ProviderOption } from './types';

export function* allocateUserSelfApply(payload: AllocatePayload) {
  const options = {
    method: 'POST',
    body: JSON.stringify(payload),
  };
  const { json }: { json: { success: boolean } } = yield call(makeApiRequest, { path: 'admin/userSelfApplyBulk', options });
  if (!json?.success) {
    throw new Error('Allocate failed');
  }
  return json;
}

export function* getProviders() {
  const { json }: { json: { success: boolean; data: ProviderOption[] } } = yield call(makeApiRequest, { path: 'admin/userSelfApply/providers' });
  if (!json?.success) {
    throw new Error('Providers fetch failed');
  }
  return json.data;
}


